<template>
  <div class="form-group centix-vue-listinput row" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
      <label v-if="!info" :class="labelCssClass" class="col-form-label">
        <slot name="label">
          <a v-if="isLinked" target="_blank" :href="linkedUri">
            {{ label }}
          </a>
          <template v-else>
           {{ label }}
          </template>
        </slot>
      </label>
      <div v-else :class="labelCssClass">
        <div class="row">
          <label class="col-form-label" :class="infoIconLabel">{{ label }}</label>
          <span class="col-auto" :class="infoIconWrapper"><img :style="infoIcon" src="@/assets/info.svg" class="info align-middle ml-3" data-toggle="tooltip" data-placement="top" v-bind:title="info"/></span>
        </div>
      </div>
      <list-input ref="input" 
        :placeholder="placeholder"
        :class="inputCssClass" 
        :value="localvalue" 
        @item-changed="itemChanged" 
        @value-changed="valueChanged" 
        :list-config="listConfig" 
        :is-enabled="isEnabled" 
        :required="required" 
        :allow-empty="allowEmpty" 
        :select-first-item="selectFirstItem"
        @on-return="$emit('on-return', $event)"
        @on-blur="$emit('on-blur', $event)"
        @on-focus="$emit('on-focus', $event)"
        @show-advanced-search="onShowAdvancedSearch" 
        :show-advanced-search="showAdvancedSearch" 
        @show-archived="onShowArchivedChanged"
        :show-create-button="showCreateButton"
        @show-create-button="onShowCreateButton"
        @getlist-done="onGetListDone">
          <slot slot-scope="result" :result="result"></slot>
          <template v-slot:results="resultSlotProps">
            <slot name="results" :results="resultSlotProps.results" :searchKey="resultSlotProps.searchKey"></slot>
          </template>
      </list-input>
      <div class="model-state-error col-12">
        {{ validationError }}
      </div>
      
      <portal to="bottomPage">
        <advanced-search-modal 
          v-if="showAdvancedSearch && hasAdvancedSearchComponent && advancedSearchOpen" 
          ref="advancedsearch" 
          :is-open="advancedSearchOpen"
          @list-item-clicked="onItemClick" 
          @item-created="onItemCreated"
          @close="() => advancedSearchOpen = false" 
          :inner-component="advancedSearchComponent"
          :advanced-search-props="listConfig.advancedSearchProps" />
      </portal>

  </div>
</template>
<script>
import listinput from 'components/Input/ListInput.vue';
import FormMixin from './formitem.js';
import AdvancedSearchModal from '@/components/AdvancedSearch/Modal.vue';

export default {
  name: 'FormListInput',
  mixins: [FormMixin],
  components: {
    'list-input': listinput,
    'advanced-search-modal': AdvancedSearchModal,
  },
  props: {
    value: Number,
    listConfig: Object,
    allowEmpty: {
      type: Boolean,
      default: true
    },
    showAdvancedSearch: {
      default: false
    },
    showCreateButton: {
      default: false
    },
    selectFirstItem: {
      default: true
    }
  },
  data () {
    return {
      formType: 'list',
      localvalue: null,
      selectedItem: null,
      showArchived: false,
      advancedSearchOpen: false
    };
  },
  mounted () {
    this.localvalue = this.value;
  },
  methods: {
    raiseValueChanged (val) {
      this.$emit('change', val);
      if (!this.preventFormChange) {
        this.emitFormChange();
      }
    },
    valueChanged (val) {
      if (val !== this.localvalue) {
        this.$log(val, this.localvalue, 'diff', this.label);
        this.raiseValueChanged(val);
      }
    },
    itemChanged (item) {
      if (this.selectedItem !== item) {
        this.selectedItem = item;
        this.$emit('item-changed', item);
      }
    },
    onShowAdvancedSearch(searchkey) {
      this.$emit('show-advanced-search', searchkey);
      if (!this.advancedSearchOpen) {
        this.listConfig.advancedSearchProps.gridProps.defaultSearchExpressions = { SEARCH: searchkey };
        this.advancedSearchOpen = true;
      }
    },
    onShowCreateButton(searchKey) {
      this.$emit('show-create-button', searchKey);
      if(this.listConfig.advancedSearchProps !== undefined) {
        this.listConfig.advancedSearchProps.pageProps.createNew((autoid) => {
          this.raiseValueChanged(autoid);
          this.onItemCreated(autoid);
        });
      }
    },
    onShowArchivedChanged(e) {
      this.showArchived = e;
    },
    onItemClick (gridRowData) {
      this.valueChanged(gridRowData.AutoID);
      this.$emit('item-changed', gridRowData);
      this.$refs.advancedsearch.close();
    },
    onItemCreated(autoid) {
      this.$emit('item-created', autoid);
    },
		onGetListDone(eventData) {
      this.$emit('getlist-done', eventData);
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    isLinked () {
      if (this.listConfig && this.listConfig.link && this.value !== null) return true;
      else return false;
    },
    linkedUri () {
      return this.listConfig.link.getLink(this.localvalue);
    },
    hasAdvancedSearchComponent () {
      return (this.listConfig && this.listConfig.advancedSearchComponent !== null && this.listConfig.advancedSearchComponent !== undefined);
    },
    advancedSearchComponent () {
      return this.listConfig.advancedSearchComponent;
    }
  },
  watch: {
    value (newvalue, oldvalue) {
      this.localvalue = newvalue;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-listinput {
  span.holder-span {
    position: relative;
    display: block;
  }
  .clear-button {
    position: absolute;
    right: 0;
    top: 0;
    background: url('../../assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 50px;
    height: 100%;
    cursor: pointer;
  }
  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }
      &.filled {
        padding-right: 25px;
        border: 2px solid #80bdff;
      }
    }
  }
  .result-items-holder {
    position: relative;
    width: 100%;
    height: 0px;
    z-index: 100;
  }
  .result-list {
    width: 100%;
    position: absolute;
    list-style: none;
    margin: 0;
    padding: 0;
    box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
    li {
      margin: 0;
      padding: 0;
      a {
        padding: 8px;
        font-weight: bold;
        width: 100%;
        display: block;
        background-color: rgba(255, 255, 255, 0.95);
        text-decoration: none;
        background-size: 100%;
      }
      &.selected a {
        background-color: #007bff;
        color: white;
      }
    }
  }
  .loading-spinner, .error-popper {
    position: absolute;
    right: 4px;
    top: 4px;
    background: #fff;
  }
  .model-state-error {
    color: $error;
  }
}
</style>
